/**
 * 文章列表
 */
import Layout from '../../pages/layout/Frame';

const adminRouter = {
    path: "/admin",
    component: Layout,
    meta: {title: '管理员'},
    name: "admin_list",
    children: [
        {
            path: "/admin/index",
            component: () => import('../../pages/admin/Admin'),
            meta: {title: '管理员',},
            name: 'admin_list',
        },
    ]
};

export default adminRouter
